import type { Video } from "@/types/video";

export const varietyVideos: Video[] = [
  {
    id: "va-01",
    title: "欢乐大本营",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20variety%20show%20poster%20of%20a%20colorful%20cheerful%20studio%20stage%20with%20confetti%20and%20glowing%20lights%2C%20hosts%20laughing%2C%20vibrant%20warm%20orange%20and%20cream%20tones%2C%20joyful%20atmosphere%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=va-01&orientation=landscape",
    type: "variety",
    region: "华语",
    year: 2025,
    rating: 8.2,
    views: 1680000,
    updateDate: "2026-10-16",
    director: "综艺组",
    actors: ["何炅炅", "汪涵涵", "谢娜娜"],
    description:
      "国内最长寿的周播综艺之一，明星嘉宾齐聚舞台，游戏、访谈、才艺轮番上演。笑声不断的周末夜晚，从这里开始。",
    tags: ["综艺", "娱乐", "访谈"],
  },
  {
    id: "va-02",
    title: "极限挑战赛",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20variety%20show%20poster%20of%20hosts%20competing%20in%20an%20outdoor%20obstacle%20course%20under%20blue%20sky%2C%20dynamic%20action%2C%20energetic%20bright%20tones%20with%20warm%20accents%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=va-02&orientation=landscape",
    type: "variety",
    region: "华语",
    year: 2024,
    rating: 8.5,
    views: 1520000,
    updateDate: "2026-10-15",
    director: "综艺组",
    actors: ["黄渤渤", "孙红雷雷", "罗志祥祥"],
    description:
      "六位常驻嘉宾组成的男人帮，在每期不同的任务中斗智斗勇。无论是体能考验还是脑力博弈，都贡献了无数名场面。",
    tags: ["综艺", "真人秀", "竞技"],
  },
  {
    id: "va-03",
    title: "明星大侦探",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20variety%20show%20poster%20of%20a%20retro%20mystery%20manor%20set%20with%20spotlights%20and%20a%20magnifying%20glass%2C%20theatrical%20detective%20theme%2C%20moody%20amber%20and%20deep%20navy%20tones%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=va-03&orientation=landscape",
    type: "variety",
    region: "华语",
    year: 2024,
    rating: 8.8,
    views: 1440000,
    updateDate: "2026-10-14",
    director: "综艺组",
    actors: ["撒贝贝", "何炅炅", "白敬敬"],
    description:
      "六位玩家每期进入一个全新剧情场景，扮演角色并破解一桩悬案。烧脑的推理与爆笑的即兴发挥，让这档综艺常青不衰。",
    tags: ["综艺", "推理", "真人秀"],
  },
  {
    id: "va-04",
    title: "声临其境",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20variety%20show%20poster%20of%20a%20voiceover%20recording%20booth%20with%20a%20microphone%20under%20warm%20spotlight%2C%20dramatic%20shadows%2C%20amber%20and%20deep%20blue%20tones%2C%20focused%20atmosphere%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=va-04&orientation=landscape",
    type: "variety",
    region: "华语",
    year: 2023,
    rating: 8.4,
    views: 980000,
    updateDate: "2026-10-13",
    director: "综艺组",
    actors: ["张铁林林", "宁静静", "王劲松松"],
    description:
      "演员们用声音演绎经典影视片段，以配音比拼技艺。一人千面的声线变换让观众直呼过瘾，也让配音这门艺术被更多人看见。",
    tags: ["综艺", "配音", "才艺"],
  },
  {
    id: "va-05",
    title: "向往的田野",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20variety%20show%20poster%20of%20a%20cozy%20rural%20farmhouse%20with%20vegetable%20garden%20and%20warm%20firelight%2C%20golden%20afternoon%20fields%2C%20peaceful%20healing%20tones%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=va-05&orientation=landscape",
    type: "variety",
    region: "华语",
    year: 2024,
    rating: 8.6,
    views: 1320000,
    updateDate: "2026-10-12",
    director: "慢生活组",
    actors: ["黄磊磊", "何炅炅", "彭昱昱"],
    description:
      "嘉宾在乡间田园自给自足，种菜、做饭、招待来客。没有剧本的慢节奏生活，治愈了无数都市人的疲惫与焦虑。",
    tags: ["综艺", "慢生活", "真人秀"],
  },
  {
    id: "va-06",
    title: "乘风破浪",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20variety%20show%20poster%20of%20female%20performers%20on%20a%20spectacular%20stage%20with%20sweeping%20lights%20and%20smoke%2C%20empowering%20energy%2C%20warm%20gold%20and%20deep%20navy%20tones%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=va-06&orientation=landscape",
    type: "variety",
    region: "华语",
    year: 2025,
    rating: 8.7,
    views: 1560000,
    updateDate: "2026-10-11",
    director: "竞演组",
    actors: ["宁静静", "那英英", "张雨绮绮"],
    description:
      "三十位不同领域的女性艺人同台竞演，通过一次次舞台打磨与团队合作重新定义自我。汗水与泪水交织，见证破浪前行的力量。",
    tags: ["综艺", "竞演", "音乐"],
  },
  {
    id: "va-07",
    title: "王牌对王牌",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20variety%20show%20poster%20of%20two%20teams%20facing%20off%20on%20a%20glitzy%20game%20show%20stage%2C%20colorful%20lights%20and%20buzzers%2C%20playful%20energetic%20tones%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=va-07&orientation=landscape",
    type: "variety",
    region: "华语",
    year: 2023,
    rating: 8.0,
    views: 1120000,
    updateDate: "2026-10-10",
    director: "综艺组",
    actors: ["沈腾腾", "贾玲玲", "华晨晨"],
    description:
      "两支固定队伍围绕不同主题展开游戏对抗，影视IP联动让节目看点十足。笑料密集，适合全家一起观看的欢乐综艺。",
    tags: ["综艺", "游戏", "娱乐"],
  },
  {
    id: "va-08",
    title: "天籁之声",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20music%20competition%20poster%20of%20a%20singer%20under%20a%20single%20dramatic%20spotlight%20on%20a%20dark%20stage%2C%20silhouette%20of%20judges%20in%20foreground%2C%20warm%20gold%20and%20deep%20navy%20tones%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=va-08&orientation=landscape",
    type: "variety",
    region: "华语",
    year: 2024,
    rating: 8.3,
    views: 1240000,
    updateDate: "2026-10-09",
    director: "音乐组",
    actors: ["那英英", "汪峰峰", "庾澄庆庆"],
    description:
      "素人歌手登上舞台，用声音打动四位导师。盲选、对战、巅峰之夜层层递进，每一季都能诞生让人记住的好嗓子。",
    tags: ["综艺", "音乐", "选秀"],
  },
  {
    id: "va-09",
    title: "舞动奇迹",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20dance%20competition%20poster%20of%20dancers%20mid-motion%20on%20an%20illuminated%20stage%20with%20dynamic%20light%20trails%2C%20expressive%20energy%2C%20warm%20amber%20and%20deep%20navy%20tones%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=va-09&orientation=landscape",
    type: "variety",
    region: "华语",
    year: 2022,
    rating: 8.1,
    views: 760000,
    updateDate: "2026-10-08",
    director: "舞蹈组",
    actors: ["杨丽萍萍", "金星星", "朱洁洁"],
    description:
      "来自不同舞种的舞者同台竞技，用身体讲述故事。现代舞、民族舞、街舞碰撞出令人惊叹的舞台，让观众重新认识舞蹈之美。",
    tags: ["综艺", "舞蹈", "竞技"],
  },
  {
    id: "va-10",
    title: "天天向上",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20talk%20variety%20show%20poster%20of%20hosts%20on%20a%20bright%20modern%20studio%20sofa%20set%2C%20friendly%20warm%20lighting%2C%20cultural%20and%20cheerful%20atmosphere%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=va-10&orientation=landscape",
    type: "variety",
    region: "华语",
    year: 2023,
    rating: 7.9,
    views: 690000,
    updateDate: "2026-10-07",
    director: "综艺组",
    actors: ["汪涵涵", "大张伟伟", "王一博博"],
    description:
      "以传播文化、分享知识为核心的脱口秀综艺，每期邀请各领域嘉宾畅聊。寓教于乐，在轻松氛围中收获见闻与感动。",
    tags: ["综艺", "访谈", "文化"],
  },
  {
    id: "va-11",
    title: "美食合伙人",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20food%20variety%20show%20poster%20of%20chefs%20cooking%20in%20a%20warm%20open%20kitchen%20with%20steaming%20dishes%2C%20cozy%20golden%20light%2C%20appetizing%20rich%20tones%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=va-11&orientation=landscape",
    type: "variety",
    region: "华语",
    year: 2024,
    rating: 8.5,
    views: 1050000,
    updateDate: "2026-10-06",
    director: "美食组",
    actors: ["谢霆锋锋", "林依轮轮", "张亮亮"],
    description:
      "明星与素人厨师搭档开餐厅，用美食招待来客。从选材到烹饪再到经营，一场关于味道、人情与合作的温暖真人秀。",
    tags: ["综艺", "美食", "真人秀"],
  },
  {
    id: "va-12",
    title: "奔跑吧朋友",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20variety%20show%20poster%20of%20runners%20sprinting%20through%20a%20colorful%20city%20street%20during%20a%20game%2C%20dynamic%20motion%2C%20bright%20energetic%20tones%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=va-12&orientation=landscape",
    type: "variety",
    region: "华语",
    year: 2025,
    rating: 8.1,
    views: 1380000,
    updateDate: "2026-10-05",
    director: "综艺组",
    actors: ["李晨晨", "郑恺恺", "杨颖颖"],
    description:
      "固定成员与飞行嘉宾展开撕名牌等经典游戏对抗，跑遍全国各大城市。体力与智力的双重比拼，让欢笑贯穿始终。",
    tags: ["综艺", "游戏", "真人秀"],
  },
  {
    id: "va-13",
    title: "青春有你",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20idol%20survival%20show%20poster%20of%20young%20trainees%20performing%20on%20a%20large%20stage%20with%20fan%20lights%2C%20hopeful%20energy%2C%20warm%20gold%20and%20deep%20navy%20tones%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=va-13&orientation=landscape",
    type: "variety",
    region: "华语",
    year: 2023,
    rating: 7.8,
    views: 910000,
    updateDate: "2026-10-04",
    director: "选秀组",
    actors: ["蔡徐坤坤", "张艺兴兴", "李荣浩浩"],
    description:
      "上百位训练生通过多轮舞台竞演争取出道位。汗水、友情与梦想在聚光灯下交织，见证年轻人逐梦的每一步。",
    tags: ["综艺", "选秀", "音乐"],
  },
  {
    id: "va-14",
    title: "脱口秀大会",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20stand-up%20comedy%20show%20poster%20of%20a%20comedian%20with%20a%20microphone%20under%20a%20warm%20spotlight%20on%20a%20brick%20wall%20stage%2C%20intimate%20club%20mood%2C%20amber%20and%20deep%20charcoal%20tones%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=va-14&orientation=landscape",
    type: "variety",
    region: "华语",
    year: 2024,
    rating: 8.6,
    views: 1470000,
    updateDate: "2026-10-03",
    director: "喜剧组",
    actors: ["李诞诞", "周奇墨墨", "呼兰兰"],
    description:
      "素人脱口秀演员同台比拼，用五分钟的段子表达对生活的观察与调侃。不止好笑，还能让人笑着笑着就红了眼眶。",
    tags: ["综艺", "脱口秀", "喜剧"],
  },
  {
    id: "va-15",
    title: "旅行日记",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20travel%20variety%20show%20poster%20of%20friends%20on%20a%20scenic%20road%20trip%20overlooking%20a%20coastal%20town%20at%20sunset%2C%20wanderlust%20mood%2C%20warm%20golden%20and%20teal%20tones%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=va-15&orientation=landscape",
    type: "variety",
    region: "华语",
    year: 2023,
    rating: 8.2,
    views: 880000,
    updateDate: "2026-10-02",
    director: "旅行组",
    actors: ["张钧甯甯", "陈意涵涵", "贾静雯雯"],
    description:
      "几位好友背上行囊踏上旅途，用镜头记录沿途的风景与人情。没有行程表，只有随性的选择与真实的相处时光。",
    tags: ["综艺", "旅行", "真人秀"],
  },
  {
    id: "va-16",
    title: "妈妈的味道",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20warm%20family%20food%20show%20poster%20of%20a%20mother%20cooking%20home%20dishes%20in%20a%20cozy%20kitchen%20with%20golden%20afternoon%20light%2C%20nostalgic%20tender%20tones%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=va-16&orientation=landscape",
    type: "variety",
    region: "华语",
    year: 2022,
    rating: 8.4,
    views: 640000,
    updateDate: "2026-10-01",
    director: "美食组",
    actors: ["母子组合", "素人家庭", "美食嘉宾"],
    description:
      "每期邀请一组母子共同下厨，复刻记忆中的家常味道。一道菜背后是一段故事，也是最朴素的亲情表达。",
    tags: ["综艺", "美食", "温情"],
  },
  {
    id: "va-17",
    title: "我型我秀",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20talent%20show%20poster%20of%20performers%20of%20all%20ages%20on%20a%20glowing%20variety%20stage%2C%20celebration%20confetti%2C%20colorful%20warm%20tones%2C%20joyful%20mood%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=va-17&orientation=landscape",
    type: "variety",
    region: "华语",
    year: 2021,
    rating: 7.7,
    views: 520000,
    updateDate: "2026-09-30",
    director: "才艺组",
    actors: ["素人选手", "导师团", "特邀评审"],
    description:
      "不限年龄与才艺的舞台，普通人也能闪闪发光。唱歌、杂技、魔术、舞蹈轮番登场，见证每一个平凡人的高光时刻。",
    tags: ["综艺", "才艺", "选秀"],
  },
  {
    id: "va-18",
    title: "萌娃当家",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20family%20variety%20show%20poster%20of%20adorable%20children%20playing%20in%20a%20bright%20cozy%20home%2C%20warm%20playful%20pastel%20tones%2C%20heartwarming%20atmosphere%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=va-18&orientation=landscape",
    type: "variety",
    region: "华语",
    year: 2023,
    rating: 8.0,
    views: 780000,
    updateDate: "2026-09-28",
    director: "亲子组",
    actors: ["明星家庭", "萌娃团", "亲子嘉宾"],
    description:
      "明星父母与孩子共同完成任务，展现真实的亲子相处日常。萌娃的金句和自然的互动，让这档节目充满治愈与欢笑。",
    tags: ["综艺", "亲子", "真人秀"],
  },
  {
    id: "va-19",
    title: "城市玩家",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20city%20exploration%20variety%20show%20poster%20of%20hosts%20discovering%20hidden%20alleyways%20and%20street%20food%20in%20a%20lively%20city%2C%20warm%20candid%20tones%2C%20adventurous%20mood%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=va-19&orientation=landscape",
    type: "variety",
    region: "华语",
    year: 2024,
    rating: 8.3,
    views: 840000,
    updateDate: "2026-09-26",
    director: "城市组",
    actors: ["本地达人", "明星嘉宾", "素人向导"],
    description:
      "嘉宾深入一座座城市的街头巷尾，寻找最地道的美食与最有趣的人。用脚步丈量城市，发现藏在日常里的惊喜。",
    tags: ["综艺", "城市", "美食"],
  },
  {
    id: "va-20",
    title: "声音的旅行",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20music%20documentary%20variety%20poster%20of%20musicians%20playing%20instruments%20in%20a%20sunlit%20forest%20clearing%2C%20acoustic%20warmth%2C%20serene%20golden%20and%20green%20tones%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=va-20&orientation=landscape",
    type: "variety",
    region: "华语",
    year: 2022,
    rating: 8.1,
    views: 560000,
    updateDate: "2026-09-24",
    director: "音乐组",
    actors: ["民谣歌手", "独立乐队", "音乐制作人"],
    description:
      "音乐人带着乐器走进山川湖海，在自然中完成一场场即兴演出。旅途与旋律交织，让观众听见最纯粹的声音。",
    tags: ["综艺", "音乐", "旅行"],
  },
  {
    id: "va-21",
    title: "喜剧之王",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20comedy%20competition%20show%20poster%20of%20comedians%20performing%20sketches%20on%20a%20colorful%20stage%20with%20props%2C%20playful%20energetic%20tones%2C%20bursting%20laughter%20mood%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=va-21&orientation=landscape",
    type: "variety",
    region: "华语",
    year: 2023,
    rating: 8.2,
    views: 950000,
    updateDate: "2026-09-22",
    director: "喜剧组",
    actors: ["沈腾腾", "马丽丽", "常远远"],
    description:
      "喜剧团队同台竞赛，用短剧、小品、默剧等形式比拼笑点。既有密集的包袱，也有让人会心一笑的生活洞察。",
    tags: ["综艺", "喜剧", "竞技"],
  },
  {
    id: "va-22",
    title: "音乐风暴",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20music%20festival%20variety%20poster%20of%20a%20crowd%20with%20raised%20hands%20in%20front%20of%20a%20huge%20lit%20stage%2C%20energetic%20night%20concert%2C%20warm%20orange%20and%20deep%20navy%20tones%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=va-22&orientation=landscape",
    type: "variety",
    region: "华语",
    year: 2025,
    rating: 8.5,
    views: 1290000,
    updateDate: "2026-09-20",
    director: "音乐组",
    actors: ["摇滚乐队", "流行歌手", "说唱厂牌"],
    description:
      "不同风格的音乐人组成战队展开音乐对抗，改编、原创、合作舞台层出不穷。一场属于耳朵的夏日风暴，燃爆每一个夜晚。",
    tags: ["综艺", "音乐", "竞演"],
  },
  {
    id: "va-23",
    title: "光影星播客",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20talk%20show%20poster%20of%20a%20director%20and%20actors%20chatting%20in%20an%20elegant%20screening%20room%2C%20warm%20cinematic%20lighting%2C%20sophisticated%20amber%20and%20deep%20navy%20tones%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=va-23&orientation=landscape",
    type: "variety",
    region: "华语",
    year: 2023,
    rating: 8.0,
    views: 620000,
    updateDate: "2026-09-18",
    director: "影评组",
    actors: ["导演嘉宾", "影评人", "演员嘉宾"],
    description:
      "每期围绕一部影片展开深度对谈，导演、演员与影评人分享幕后故事。既有专业视角，也不乏轻松八卦，影迷不可错过。",
    tags: ["综艺", "访谈", "影视"],
  },
  {
    id: "va-24",
    title: "潮流合伙人",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20fashion%20business%20variety%20poster%20of%20stylish%20people%20in%20a%20modern%20trendy%20boutique%2C%20clean%20warm%20lighting%2C%20chic%20amber%20and%20cream%20tones%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=va-24&orientation=landscape",
    type: "variety",
    region: "华语",
    year: 2022,
    rating: 7.9,
    views: 540000,
    updateDate: "2026-09-16",
    director: "潮流组",
    actors: ["陈冠冠", "王鹤鹤", "程潇潇"],
    description:
      "几位明星合伙经营一家潮流店铺，从选址、选品到运营亲力亲为。时尚与商业碰撞，展现潮流背后的经营智慧。",
    tags: ["综艺", "潮流", "经营"],
  },
  {
    id: "va-25",
    title: "美食大冒险",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20food%20adventure%20variety%20poster%20of%20hosts%20tasting%20colorful%20street%20food%20at%20a%20bustling%20night%20market%2C%20steaming%20dishes%2C%20warm%20vibrant%20tones%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=va-25&orientation=landscape",
    type: "variety",
    region: "华语",
    year: 2024,
    rating: 8.4,
    views: 1010000,
    updateDate: "2026-09-14",
    director: "美食组",
    actors: ["美食博主", "明星嘉宾", "本地大厨"],
    description:
      "一群吃货穿梭于各地的夜市与街头，寻找隐藏的宝藏美味。吃遍大江南北的同时，也记录下食物背后的人间烟火。",
    tags: ["综艺", "美食", "旅行"],
  },
  {
    id: "va-26",
    title: "巅峰对决",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20sports%20competition%20variety%20poster%20of%20athletes%20competing%20in%20a%20bright%20arena%20with%20dramatic%20lighting%2C%20intense%20energy%2C%20warm%20orange%20and%20cool%20blue%20tones%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=va-26&orientation=landscape",
    type: "variety",
    region: "华语",
    year: 2023,
    rating: 8.1,
    views: 700000,
    updateDate: "2026-09-12",
    director: "竞技组",
    actors: ["体育明星", "素人选手", "专业教练"],
    description:
      "素人与专业运动员同场竞技，挑战体能极限。每一场对决都悬念迭起，展现体育精神与永不言弃的拼搏。",
    tags: ["综艺", "竞技", "运动"],
  },
  {
    id: "va-27",
    title: "快乐出发",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20friendship%20travel%20variety%20poster%20of%20a%20group%20of%20friends%20laughing%20in%20a%20colorful%20camper%20van%20on%20a%20country%20road%2C%20joyful%20warm%20tones%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=va-27&orientation=landscape",
    type: "variety",
    region: "华语",
    year: 2022,
    rating: 7.8,
    views: 580000,
    updateDate: "2026-09-10",
    director: "旅行组",
    actors: ["固定嘉宾团", "飞行嘉宾", "素人朋友"],
    description:
      "一群好友开着房车踏上公路旅行，在旅途中完成各种有趣的挑战。笑声洒满一路，诠释了最纯粹的友情与快乐。",
    tags: ["综艺", "旅行", "真人秀"],
  },
  {
    id: "va-28",
    title: "极限运动",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20extreme%20sports%20variety%20poster%20of%20athletes%20skateboarding%20and%20climbing%20in%20an%20urban%20park%2C%20dynamic%20action%2C%20warm%20sunset%20and%20cool%20grey%20tones%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=va-28&orientation=landscape",
    type: "variety",
    region: "欧美",
    year: 2024,
    rating: 8.2,
    views: 760000,
    updateDate: "2026-09-08",
    director: "极限组",
    actors: ["极限运动员", "明星挑战者", "专业裁判"],
    description:
      "滑板、攀岩、冲浪、跑酷，极限运动员与明星共同挑战高难度项目。惊险刺激的画面背后，是无数次跌倒又爬起的坚持。",
    tags: ["综艺", "运动", "竞技"],
  },
  {
    id: "va-29",
    title: "星月对话",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20late%20night%20talk%20show%20poster%20of%20a%20host%20and%20guest%20in%20a%20warm%20intimate%20studio%20with%20city%20lights%20through%20window%2C%20moody%20amber%20and%20deep%20navy%20tones%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=va-29&orientation=landscape",
    type: "variety",
    region: "华语",
    year: 2023,
    rating: 8.6,
    views: 900000,
    updateDate: "2026-09-06",
    director: "访谈组",
    actors: ["文化名人", "艺术家", "行业领袖"],
    description:
      "深夜长谈类节目，每期邀请一位嘉宾聊人生、聊选择、聊热爱。没有剧本，只有真诚的对话与思想的碰撞。",
    tags: ["综艺", "访谈", "文化"],
  },
  {
    id: "va-30",
    title: "天天美食",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20daily%20cooking%20show%20poster%20of%20a%20chef%20presenting%20a%20beautiful%20finished%20dish%20in%20a%20bright%20kitchen%20studio%2C%20appetizing%20warm%20tones%2C%20inviting%20mood%2C%20highly%20detailed%20editorial%20composition&width=800&height=450&seq=va-30&orientation=landscape",
    type: "variety",
    region: "华语",
    year: 2021,
    rating: 7.6,
    views: 480000,
    updateDate: "2026-09-04",
    director: "美食组",
    actors: ["家常菜大厨", "美食嘉宾", "素人食客"],
    description:
      "每期教你一道拿手家常菜，从食材挑选到火候把控细致讲解。简单实用，是无数观众厨房里的美食启蒙。",
    tags: ["综艺", "美食", "生活"],
  },
];